module.exports = __webpack_public_path__ + "img/logo_c.6e229538.png";